import {
    $get,
    $post
  } from '@/utils/http'
  // 党纪法规
export default {
    // 分类查询
  getFenlei(params) {
      return $post('/portal/websit/classificationSystem/listClassificationo', params)
  },
  getFenlei1(params) {
    return $post('/portal/websit/classificationSystem/listClassificationo', params)
},
  // 分类详情
  goDetail1(params) {
    return $post('/portal/websit/classificationSystem/getPatrolInfoById', params)
  },
   // 分类
   Fenlei(params) {
    return $get('/common/dict/item-list', params)  
},
// 分类
Fenlei1(params) {
    return $get('/common/dict/item-list', params)  
  },
  Fenlei2(params) {
    return $get('/common/dict/item-list', params)  
},
   //小贴士
  getTips(params) {
   
    return $post('/portal/websit/tipsInfo/listPatrolInfo', params)
  },
  //小贴士详情
  getTips1(params) {
  
   return $post('/portal/websit/tipsInfo/getPatrolInfoById', params)
 },
  //  搜索
  getSearch(params) {
    return $post('/portal/websit/classificationSystem/listQuery', params)
  },
  //  搜索详情
  getSearch1(params) {
    return $post('/portal/websit/classificationSystem/getPatrolInfoById', params)
  },
  }
  